import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/service/apiServices';
import * as $ from "jquery";
import { Global } from '../../../global';
import { Location } from '@angular/common';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../../../service/auth/auth.service'
import Swal from 'sweetalert2';

@Component({
    selector: 'app-prioridade-senha',
    templateUrl: './prioridade-senha.component.html',
    styleUrls: ['./prioridade-senha.component.css']
})

export class PrioridadeSenhaComponent implements OnInit {

    prioridade: any = {
        ativo: true,
        cor: '#000000'
    };
    uid: any = null;
    loading: any = false;

    constructor(
        private route: ActivatedRoute,
        public service: ApiService,
        private router: Router,
        public global: Global,
        private location: Location,
        private authService: AuthService
    ) { }

    goBack() {
        this.location.back();
    }

    ngOnInit() {
        Swal.fire('Favor aguarde');
        Swal.showLoading();
        const uid = this.route.snapshot.paramMap.get('uuid');
        this.uid = uid;
        if (this.uid) {
            this.obterPrioridade(this.uid);
        } else {
            Swal.close();
        }
    }

    obterPrioridade(id) {
        this.service.Get(`PrioridadeSenha/${id}`).then(res => {
            Swal.close();
            this.loading = false;
            this.prioridade = res;
        }).catch(res => {
            Swal.close();
            this.loading = false;

            if (res && (res.status == 401 || (res.error && res.error.status == 401))) {
                this.authService.logoutUser()
                return;
            }

            if (res && res.error && res.error.erros && res.error.erros[0]) {
                Swal.fire('Erro', `${res.error.erros[0].messagem}`, 'error');
            } else {
                Swal.fire('Erro', 'Ocorreu um erro ao buscar a prioridade', 'error');
            }
        });
    }

    salvar(item: any) {
        if (!item.nome) {
            Swal.fire('Atenção', `O nome da prioridade é obrigatório`, 'warning');
            return
        }

        if (item.peso === null || item.peso === undefined) {
            Swal.fire('Atenção', `O peso da prioridade é obrigatório`, 'warning');
            return
        }

        if (!item.cor) {
            Swal.fire('Atenção', `A cor da prioridade é obrigatória`, 'warning');
            return
        }

        var obj = {
            "nome": item.nome,
            "descricao": item.descricao || "",
            "peso": item.peso,
            "cor": item.cor,
            "ativo": item.ativo
        }

        this.loading = true;
        Swal.fire('Favor aguarde');
        Swal.showLoading();

        if (this.prioridade.id) {
            this.service.Put(`PrioridadeSenha/${this.prioridade.id}`, obj).then(res => {
                Swal.close();
                this.loading = false;
                this.prioridade = res;
                Swal.fire({
                    icon: 'success',
                    title: 'Sucesso!',
                    html: 'Prioridade atualizada com sucesso!'
                }).then(
                    result => {
                        if (result.isConfirmed) {
                            this.goBack();
                        }
                    }
                );
            }).catch(res => {
                Swal.close();
                this.loading = false;

                if (res && (res.status == 401 || (res.error && res.error.status == 401))) {
                    this.authService.logoutUser()
                    return;
                }

                if (res && res.error && res.error.erros && res.error.erros[0]) {
                    Swal.fire('Erro', `${res.error.erros[0].messagem}`, 'error');
                } else {
                    Swal.fire('Erro', 'Ocorreu um erro ao atualizar a prioridade', 'error');
                }
            });
        } else {
            this.service.Post(`PrioridadeSenha`, obj).then(res => {
                Swal.close();
                this.loading = false;
                this.prioridade = res;
                Swal.fire({
                    icon: 'success',
                    title: 'Sucesso!',
                    html: 'Prioridade criada com sucesso!'
                }).then(
                    result => {
                        if (result.isConfirmed) {
                            this.goBack();
                        }
                    }
                );
            }).catch(res => {
                Swal.close();
                this.loading = false;

                if (res && (res.status == 401 || (res.error && res.error.status == 401))) {
                    this.authService.logoutUser()
                    return;
                }

                if (res && res.error && res.error.erros && res.error.erros[0]) {
                    Swal.fire('Erro', `${res.error.erros[0].messagem}`, 'error');
                } else {
                    Swal.fire('Erro', 'Ocorreu um erro ao criar a prioridade', 'error');
                }
            });
        }
    }

    changeStatusestab() {
        // Toggle ativo
    }
}
